import { apiClient } from '@/lib/apiClient';
import type {
  FornecedorResumo,
  FornecedorDetalhe,
  CriarFornecedorRequest,
  AtualizarFornecedorRequest,
  PaginadoResponse,
} from '../types';

const BASE = '/api/compras/fornecedores';

export const fornecedorService = {
  async getAll(pagina = 1, tamanhoPagina = 20, apenasAtivos = true): Promise<PaginadoResponse<FornecedorResumo>> {
    const { data } = await apiClient.get<PaginadoResponse<FornecedorResumo>>(BASE, {
      params: { pagina, tamanhoPagina, apenasAtivos },
    });
    return data;
  },

  async buscar(q: string, limite = 20): Promise<FornecedorResumo[]> {
    const { data } = await apiClient.get<FornecedorResumo[]>(`${BASE}/busca`, {
      params: { q, limite },
    });
    return data;
  },

  async getById(id: number): Promise<FornecedorDetalhe> {
    const { data } = await apiClient.get<FornecedorDetalhe>(`${BASE}/${id}`);
    return data;
  },

  async create(request: CriarFornecedorRequest): Promise<FornecedorDetalhe> {
    const { data } = await apiClient.post<FornecedorDetalhe>(BASE, request);
    return data;
  },

  async update(id: number, request: AtualizarFornecedorRequest): Promise<FornecedorDetalhe> {
    const { data } = await apiClient.put<FornecedorDetalhe>(`${BASE}/${id}`, request);
    return data;
  },
};
